import styled from 'styled-components';
import { textBase } from 'common/common-styles';

export const PaymentInfoText = styled.p`
  ${textBase}
  font-size: 14px;
  line-height: 1.5;
`;
